// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"e9-z","disabled":"f9-z","label":"g9-z"};